// The NFC Portal guide (18_NFCPortal.jsx · ModuleHelp, Max 01/11).
const en = {
  roleT: 'Who you are here',
  roleB: 'Your account and role. A coordinator raises requests; a manager reviews them. If you hold both, switch between them here.',
  typeT: 'Issuance or Replacement',
  typeB: 'Choose Issuance for new NFC labels, or Replacement to swap labels already issued.',
  importT: 'Import the items',
  importB: 'Download the template, fill it in and choose the CSV. The preview shows each row and flags the ones that are invalid, so fix them before saving.',
  saveT: 'Save the request',
  saveB: 'Save keeps it as not submitted. Send it for approval afterwards from your request list.',
  mineT: 'Your requests',
  mineB: 'Every request you raised with its status. Use the buttons in Action to view, edit, send for approval or delete; once approved you can download the output file.',
  reviewT: 'Requests to review',
  reviewB: 'Requests waiting for a decision. Open one to check its items, then approve it (the output file is generated) or reject it with a reason.',
};
const ko = {
  roleT: '내 계정과 역할',
  roleB: '현재 계정과 역할입니다. 코디네이터는 요청을 작성하고 매니저는 검토합니다. 두 역할이 모두 있으면 여기서 전환하세요.',
  typeT: 'Issuance 또는 Replacement',
  typeB: '새 NFC 라벨은 Issuance, 이미 발급한 라벨 교체는 Replacement를 선택하세요.',
  importT: '항목 가져오기',
  importB: '템플릿을 내려받아 작성한 뒤 CSV를 선택하세요. 미리보기에서 각 행과 오류 행을 확인하고, 저장 전에 수정하세요.',
  saveT: '요청 저장',
  saveB: '저장하면 미제출 상태로 보관됩니다. 이후 요청 목록에서 승인 요청을 보내세요.',
  mineT: '내 요청',
  mineB: '직접 작성한 모든 요청과 상태입니다. 작업 버튼으로 보기, 수정, 승인 요청, 삭제를 하고, 승인되면 결과 파일을 내려받을 수 있습니다.',
  reviewT: '검토할 요청',
  reviewB: '결정을 기다리는 요청입니다. 열어서 항목을 확인한 뒤 승인(결과 파일 생성)하거나 사유를 적어 반려하세요.',
};
const vi = {
  roleT: 'Bạn là ai ở đây',
  roleB: 'Tài khoản và vai trò của bạn. Coordinator tạo yêu cầu, Manager duyệt yêu cầu. Nếu có cả hai vai trò, bạn đổi qua lại tại đây.',
  typeT: 'Issuance hay Replacement',
  typeB: 'Chọn Issuance để cấp nhãn NFC mới, hoặc Replacement để thay nhãn đã cấp.',
  importT: 'Nhập danh sách hàng',
  importB: 'Tải template, điền xong rồi chọn file CSV. Phần xem trước hiện từng dòng và đánh dấu dòng lỗi, hãy sửa trước khi lưu.',
  saveT: 'Lưu yêu cầu',
  saveB: 'Lưu xong yêu cầu ở trạng thái chưa gửi. Sau đó gửi duyệt từ danh sách yêu cầu của bạn.',
  mineT: 'Yêu cầu của bạn',
  mineB: 'Mọi yêu cầu bạn đã tạo kèm trạng thái. Dùng các nút ở cột Action để xem, sửa, gửi duyệt hoặc xóa; khi đã duyệt bạn tải được file kết quả.',
  reviewT: 'Yêu cầu cần duyệt',
  reviewB: 'Các yêu cầu đang chờ quyết định. Mở từng yêu cầu để kiểm tra, rồi duyệt (file kết quả được tạo) hoặc từ chối kèm lý do.',
};
const zh = {
  roleT: '你的身份',
  roleB: '显示你的账号和角色。Coordinator 提交申请，Manager 负责审核。如果两种角色都有，可在此切换。',
  typeT: 'Issuance 或 Replacement',
  typeB: '新 NFC 标签选择 Issuance，更换已发放的标签选择 Replacement。',
  importT: '导入明细',
  importB: '下载模板，填写后选择 CSV 文件。预览会列出每一行并标出无效行，保存前请先修正。',
  saveT: '保存申请',
  saveB: '保存后申请处于未提交状态，之后请在申请列表中发送审批。',
  mineT: '我的申请',
  mineB: '你提交的所有申请及其状态。用操作列的按钮查看、编辑、发送审批或删除；批准后可下载结果文件。',
  reviewT: '待审核申请',
  reviewB: '等待决定的申请。打开后核对明细，然后批准（生成结果文件）或填写理由拒绝。',
};
const dictionary = { ns: 'tourNfc', en, ko, vi, zh };
export default dictionary;
